import React, { useEffect, useState } from "react";
import { Event } from "components/Comet";
import {
    Button,
    FormControl,
    FormGroup,
    ControlLabel,
    Glyphicon
} from "react-bootstrap";
import Loading from "components/Loading";
import Request from "request";
import DeleteConfirmOverlay from "../../UI/DeleteConfirmOverlay";

const Row = ({ id, place, title, count, onRemove, header }) => {
    return <div style={{
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px solid gray',
        padding: '1rem',
        color: header ? 'gray' : 'inherit',
        fontSize: header ? '1.25rem' : 'inherit'
    }}
    >
        <div style={{ flexBasis: '3rem', color: 'gray' }}>#{place}</div>
        <div style={{ flexGrow: 1 }}>{title}</div>
        <div style={{ flexBasis: '10rem', textAlign: 'center' }}>{count}</div>
        <div style={{ flexBasis: '4rem' }}>
            {id && <DeleteConfirmOverlay title="Удалить этот ответ?" buttonText="Удалить" onConfirm={() => onRemove(id)}>
                <Button
                    bsSize="small"
                    bsStyle="danger"
                >
                    <Glyphicon glyph="trash" />
                </Button>
            </DeleteConfirmOverlay>}
        </div>
    </div>
}

const ManageOpenPollResult = ({ pollId, event }) => {
    const [loading, setLoading] = useState(true);
    const [poll, setPoll] = useState(null);
    const [answers, setAnswers] = useState([]);
    const [sorting, setSorting] = useState("place");

    useEffect(() => {
        if (poll?.id === pollId) return;

        if (!pollId) {
            setPoll(null);
        } else {
            setLoading(true);
            Request.get(`/api/cp/event/${event.eventPassword}/poll/${pollId}`)
                .then(poll => {
                    setPoll(poll);
                    setLoading(false);
                });
        }
    }, [pollId]);

    useEffect(() => {
        setAnswers(Array.isArray(poll?.answer) ?
            poll.answer.sort((a, b) => b.count - a.count).map((answer, index) => ({ ...answer, place: index + 1 })) :
            []);
    }, [poll])

    const updatePoll = (poll, newPoll) => {
        if (!poll || !newPoll || poll.id !== newPoll.id) {
            return poll;
        } else {
            return { ...poll, ...newPoll };
        }
    }

    const removeAnswer = (answerId) => {
        Request.delete(`/api/cp/event/${event.eventPassword}/poll/${pollId}/answer/${answerId}`);
    }

    if (loading) return <Loading>Загрузка данных опроса</Loading>;
    if (!poll) return <>Не существует такого опроса</>;

    return <>
        <h4>Облако слов</h4>
        <h3>{poll.textRu}</h3>
        <div style={{ marginTop: '2rem' }}>
            <FormGroup style={{ display: 'flex', alignItems: 'baseline', gap: '1rem', maxWidth: 'fit-content' }}>
                <ControlLabel>Сортировка</ControlLabel>
                <FormControl
                    componentClass="select"
                    value={sorting}
                    onChange={e => setSorting(e.target.value)}
                >
                    <option value="place">По популярности</option>
                    <option value="id">Сначала новые</option>
                </FormControl>
            </FormGroup>
            <Row place={""} title={"Слово"} count={"Упоминаний"} header />
            {answers
                .sort((a, b) => sorting === 'place' ? a[sorting] - b[sorting] : b[sorting] - a[sorting])
                .map((answer) =>
                    <Row
                        key={answer.id}
                        id={answer.id}
                        place={answer.place}
                        title={answer.textRu || answer.textEn}
                        count={answer.count}
                        onRemove={removeAnswer}
                    />)
            }
        </div>
        <Event event="update:poll" handler={(poll) => setPoll(prev => updatePoll(prev, poll))} />
        <Event event="delete:poll/answer" handler={answer => setPoll(poll => ({ ...poll, answer: poll.answer.filter(({ id }) => id !== answer?.id) }))} />
    </>
}

export default ManageOpenPollResult;